<template>
    <div class="flex-1 bg-white rounded-medium p-7 pb-0 md:pb-7">
        <div class="welcome-text">
            <h2 class="title-copy" v-if="$store.getters.isCuratedLink">Hello,</h2>
            <p class="body-copy" v-if="$store.getters.isCuratedLink">
                Create your account and complete your purchase by providing billing details and a payment method.
            </p>
            <p class="body-copy" v-if="$store.getters.isPartnerLink && ($store.getters.partnerHasAccess || $store.getters.isLegacyBundleId)">
                Your Keap partner will be granted access to your application. If you have any questions, please contact your partner.
            </p>
        </div>
        <form ref="paymentForm" @submit.prevent="$emit('submitPayment')">
            <h1 class="font-walsheim text-xl font-bold mb-6">Payment details</h1>
            <h2 class="font-walsheim text-lg mb-6">Billing address</h2>
            <Address class="mb-12" />
            <h2 class="font-walsheim text-lg mb-6">Payment information</h2>
            <UserInfo class="mb-12" />
            <h2 class="font-walsheim text-lg mb-6">Payment method</h2>
            <CardDetails ref="cardDetails" />
            <EhawkTalon ref="ehawkTalon" />
        </form>
    </div>
</template>

<script>
import AttachmentItem from '@/BuyNow/Components/AttachmentItem.vue';
import CardDetails from '@/BuyNow/Components/inputs/Groups/CardDetails.vue';
import UserInfo from '@/BuyNow/Components/inputs/Groups/UserInfo.vue';
import Address from '@/BuyNow/Components/inputs/Groups/Address.vue';
import EhawkTalon from '@/BuyNow/Components/inputs/EhawkTalon.vue';

export default {
    components: {
        AttachmentItem,
        CardDetails,
        UserInfo,
        Address,
        EhawkTalon,
    },
    methods: {
        async tokenize() {
            this.$refs.ehawkTalon.updateTalon();
            await this.$refs.cardDetails.tokenize();
        }
    },
    emits: [
        'submit-payment'
    ],
    expose: [
        'tokenize'
    ],
};
</script>

<style lang="postcss" scoped>
.welcome-text {
    &.welcome-text:has(.body-copy) {
        @apply mb-6;
    }
    .title-copy {
        @apply font-walsheim text-lg mb-2.5;
    }
    .body-copy {
        @apply text-normal font-normal mb-2.5 last:mb-0;
    }
}
</style>
